import a11yEN from '@monorepo/shared/src/translations/en-US/a11y.json';
import uiEN from './en-US/ui.json';
import altEN from './en-US/alt.json';
import CommonEN from './en-US/common.json';
import ModalEN from './en-US/modal.json';
import HomeEN from './en-US/home.json';
import ReportsEN from './en-US/reports.json';
import RewardsEN from './en-US/rewards.json';
import ActivitiesEN from './en-US/activities.json';
import LetterBooksEN from '@monorepo/shared/src/translations/en-US/letter-books.json';

import uiES from './es-US/ui.json';
import altES from './es-US/alt.json';
import a11yEs from '@monorepo/shared/src/translations/es-US/a11y.json';
import CommonES from './es-US/common.json';
import ModalES from './es-US/modal.json';
import HomeES from './es-US/home.json';
import ReportsES from './en-US/reports.json';
import RewardsES from './es-US/rewards.json';
import ActivitiesES from './es-US/activities.json';
import LetterBooksES from '@monorepo/shared/src/translations/es-US/letter-books.json';

const i18n = {
  resourceMap: {
    'en-US': {
      a11y: a11yEN,
      common: CommonEN,
      modal: ModalEN,
      ui: uiEN,
      alt: altEN,
      home: HomeEN,
      reports: ReportsEN,
      rewards: RewardsEN,
      activities: ActivitiesEN,
      letterBooks: LetterBooksEN,
    },
    'es-US': {
      a11y: a11yEs,
      common: CommonES,
      modal: ModalES,
      ui: uiES,
      alt: altES,
      home: HomeES,
      reports: ReportsES,
      rewards: RewardsES,
      activities: ActivitiesES,
      letterBooks: LetterBooksES,
    },
  },
};

export default i18n;
